module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-4-b2818be2c64a948b551253fe2eeb4278.jpg";